export const RESUME_URL =
  "https://drive.google.com/file/d/1_HPcj6ewVLDHIZ8HYJqQYYd4b2EAjQ3N/view";
export const GITHUB_URL = "https://github.com/Joseph-Galante";
export const LINKEDIN_URL =
  "https://www.linkedin.com/in/joseph-galante-950426195/";
export const SCENE_URL = "https://www.scene.health/";

export const FLEX_HORIZONTAL_LIST = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "flex-start",
  alignItems: "center",
};

export const FLEX_VERTICAL_LIST = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
};

export const HARD_SKILLS = [
  "JavaScript",
  "HTML",
  "CSS",
  "React",
  "Node",
  "PostgreSQL",
  "Git",
  "Bitbucket",
  "AWS",
  "GCP",
  "C#",
  "Python",
  "Figma",
  "TypeScript",
  "Apollo",
  "GraphQL",
  "C++",
  "Unreal 5",
  "Blender",
];

export const SOFT_SKILLS = [
  "Customer Service",
  "Positive Attitude",
  "Self-Motivated",
  "Quick Learner",
  "Communication",
  "Adaptation",
  "Perfectionist",
  "Public Speaking",
  "Collaboration",
];
